import React from 'react';
const MessageBusStateContext = /*#__PURE__*/React.createContext();
const MessageBusDispatchContext = /*#__PURE__*/React.createContext();
const initialState = {
  activityTimestamp: 0,
  events: [],
  replies: [],
  topics: [],
  my: {
    replies: [],
    topics: []
  },
  update_in_progress: false
};

/** REDUCER **/
function MessageBusReducer(state, action) {
  switch (action.type) {
    case 'ADD_ITEM_TO_REPLIES':
      return {
        ...state,
        replies: [...state.replies, action.payload]
      };
    case 'ADD_EVENT':
      return {
        ...state,
        events: [...state.events, action.payload]
      };
    case 'ADD_ITEM_TO_TOPICS':
      return {
        ...state,
        topics: [...state.topics, action.payload]
      };
    case 'ADD_ITEM_TO_MY_REPLIES':
      return {
        ...state,
        my: {
          ...state.my,
          replies: [...state.my.replies, action.payload]
        }
      };
    case 'ADD_ITEM_TO_MY_TOPICS':
      return {
        ...state,
        my: {
          ...state.my,
          topics: [...state.my.topics, action.payload]
        }
      };
    case 'INIT_TOPICS':
      return {
        ...state,
        topics: []
      };
    case 'INIT_REPLIES':
      return {
        ...state,
        replies: []
      };
    case 'SET_ACTIVITY_TIMESTAMP':
      return {
        ...state,
        activityTimestamp: action.payload
      };
    case 'SET_UPDATE_IN_PROGRESS':
      return {
        ...state,
        update_in_progress: action.payload
      };
    case 'UPDATE_REPLIES':
      return {
        ...state,
        replies: action.payload
      };
    case 'UPDATE_TOPICS':
      return {
        ...state,
        topics: action.payload
      };
    case 'UPDATE_MY_TOPICS_REPLIES':
      return {
        ...state,
        my: action.payload
      };
    case 'UPDATE_INITAL_STATE':
      return action.payload;
    default:
      {
        throw new Error('Unhandled action type caught');
      }
  }
}

/** PROVIDER **/
function MessageBusProvider(_ref) {
  let {
    value,
    children
  } = _ref;
  const [state, dispatch] = React.useReducer(MessageBusReducer, initialState);
  return /*#__PURE__*/React.createElement(MessageBusStateContext.Provider, {
    value: state
  }, /*#__PURE__*/React.createElement(MessageBusDispatchContext.Provider, {
    value: dispatch
  }, children));
}

/** STATE/DISPATCH HOOKS **/
function useMessageBusState() {
  const context = React.useContext(MessageBusStateContext);
  if (context === undefined) {
    throw new Error('useMessageBusState must be used within a MessageBusProvider');
  }
  return context;
}
function useMessageBusDispatch() {
  const context = React.useContext(MessageBusDispatchContext);
  if (context === undefined) {
    throw new Error('useMessageBusDispatch must be used within a MessageBusProvider');
  }
  return context;
}

/** API **/
/** no API defined for the messagebus provider **/

const messageBusUtil = {
  createPayload: data => {
    return {
      ts: Date.now(),
      data: data
    };
  }
};
export { MessageBusProvider, useMessageBusState, useMessageBusDispatch, messageBusUtil };
//# sourceMappingURL=index.js.map